import { deleteData, getData, postData } from "../api/api";
import type { PageResponse } from "../types/dashboard";

const BASE = "/chat-query-examples";

export type ChatQueryExampleKind = "OPENSEARCH" | "SQL" | "MONGO";

export interface ChatQueryExampleQuery {
  kind: ChatQueryExampleKind;
  tool?: string;
  indexName?: string;
  searchType?: string;
  adaptorId?: string;
  adaptorName?: string;
  adaptorType?: string;
  query: unknown;
}

export interface ChatQueryExample {
  id: string;
  title?: string;
  userQuestion?: string;
  answerSummary?: string;
  queries?: ChatQueryExampleQuery[];
  tools?: string[];
  indices?: string[];
  resources?: Record<string, unknown>;
  correlationId?: string;
  messageId?: string;
  responseType?: string;
  createdByUsername?: string;
  chunkCount?: number;
  status?: "READY" | "FAILED";
  errorMessage?: string;
  createdDate?: string;
}

export interface ChatQueryExamplePromoteRequest {
  userQuestion: string;
  answerSummary?: string;
  title?: string;
  queries: ChatQueryExampleQuery[];
  tools?: string[];
  resources?: Record<string, unknown>;
  correlationId?: string;
  messageId?: string;
  responseType?: string;
}

export const chatQueryExampleService = {
  list: (page = 0, size = 20) =>
    getData(`${BASE}?page=${page}&size=${size}`) as Promise<PageResponse<ChatQueryExample>>,

  get: (id: string) => getData(`${BASE}/${id}`) as Promise<ChatQueryExample>,

  promote: (body: ChatQueryExamplePromoteRequest) =>
    postData(BASE, body) as Promise<ChatQueryExample>,

  /** Message ids of a conversation that are already saved as examples. */
  savedMessageIds: async (correlationId: string): Promise<string[]> => {
    const res = (await getData(
      `${BASE}/saved?correlationId=${encodeURIComponent(correlationId)}`
    )) as { messageIds?: string[] };
    return res?.messageIds ?? [];
  },

  remove: (id: string) => deleteData(`${BASE}/${id}`),
};
